import React from 'react';
import { UserPlus, Download, Info } from 'lucide-react';
import './AddImportUsersTab.css';

const AddImportUsersTab: React.FC = () => {
  return (
    <div className="trainer-user-import-container">
      <div className="trainer-user-import-card">
        <div className="trainer-user-import-card-header">
          <div className="trainer-user-import-card-icon orange">
            <UserPlus size={28} />
          </div>
          <div className="trainer-user-import-card-title">
            <h2>Add Single User</h2>
            <p>Create a new user account manually</p>
          </div>
        </div>

        <div className="trainer-user-import-form-row">
          <div className="trainer-user-import-form-group">
            <label className="trainer-user-import-form-label">First Name</label>
            <input type="text" className="trainer-user-import-form-input" placeholder="John" />
          </div>
          <div className="trainer-user-import-form-group">
            <label className="trainer-user-import-form-label">Last Name</label>
            <input type="text" className="trainer-user-import-form-input" placeholder="Doe" />
          </div>
        </div>

        <div className="trainer-user-import-form-group">
          <label className="trainer-user-import-form-label">Email</label>
          <input type="email" className="trainer-user-import-form-input" placeholder="john.doe@company.com" />
        </div>

        <div className="trainer-user-import-form-group">
          <label className="trainer-user-import-form-label">Department</label>
          <select className="trainer-user-import-form-input">
            <option>Select</option>
            <option>Engineering</option>
            <option>Sales</option>
            <option>HR</option>
            <option>Design</option>
          </select>
        </div>

        <div className="trainer-user-import-form-group">
          <label className="trainer-user-import-form-label">Job Title</label>
          <input type="text" className="trainer-user-import-form-input" placeholder="Software Engineer" />
        </div>

        <div className="trainer-user-import-form-group">
          <label className="trainer-user-import-form-label">Manager (Optional)</label>
          <input type="text" className="trainer-user-import-form-input" />
        </div>

        <button className="trainer-user-import-submit-btn">
          <UserPlus size={18} />
          Create User
        </button>
      </div>

      <div className="trainer-user-import-card">
        <div className="trainer-user-import-card-header">
          <div className="trainer-user-import-card-icon blue">
            <Download size={28} />
          </div>
          <div className="trainer-user-import-card-title">
            <h2>Bulk Import</h2>
            <p>Import multiple users from CSV file</p>
          </div>
        </div>

        <div className="trainer-user-import-info-box">
          <div className="trainer-user-import-info-title">
            <Info size={18} />
            CSV Format Requirements
          </div>
          <ul className="trainer-user-import-info-list">
            <li>Required: First Name, Last Name, Email, Department</li>
            <li>Optional: Job Title, Manager Email, Phone</li>
            <li>Max file size: 10MB</li>
          </ul>
        </div>

        <button className="trainer-user-import-download-btn">
          <Download size={18} />
          Download CSV Template
        </button>

        <div className="trainer-user-import-upload-area">
          <div className="trainer-user-import-upload-icon">
            <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
              <path d="M28 14V35M28 14L21 21M28 14L35 21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M14 35V42C14 43.1046 14.8954 44 16 44H40C41.1046 44 42 43.1046 42 42V35" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
            </svg>
          </div>
          <div className="trainer-user-import-upload-text">Drop CSV file here or click to browse</div>
          <div className="trainer-user-import-upload-subtext">Supports .csv files up to 10MB</div>
        </div>

        <button className="trainer-user-import-submit-btn">
          <Download size={18} />
          Import Users
        </button>
      </div>
    </div>
  );
};

export default AddImportUsersTab;
